import {createPageableParams} from '@/modules/core/services/table-utils';
import WrapperService from '@/modules/core/services/wrapper-service';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/users'

const sortTableFields = ["formattedFirstLogin", "formattedLastLogin"];
const sortDatabaseFields = ["firstLogin", "lastLogin"];

const serviceName = 'User-Service: ';

export default class UsersService {

  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readAllPaginatedFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page,size,search,sort,sortAsc,sortTableFields,sortDatabaseFields)
    await WrapperService.get(API_URL + '/page', {params : params}, serviceName, successF, errorF);
  }

  static async readAllPaginatedWithPrivilegesFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page,size,search,sort,sortAsc,sortTableFields,sortDatabaseFields)
    await WrapperService.get(API_URL + '/page/privileges', {params : params}, serviceName, successF, errorF);
  }

  static async readFilteredPaginatedWithPrivilegesFromAPI(page, size, sort, sortAsc, filter, successF, errorF) {
    let params = createPageableParams(page, size, '', sort, sortAsc,sortTableFields,sortDatabaseFields)
    await WrapperService.post(API_URL + '/page/privileges?' + params, filter, serviceName, successF, errorF);
  }

  static async readFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + '/' + id, null, serviceName, successF, errorF);
  }

  static async readScaledDownFromAPI(userId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + userId + '/scaled-down', null, serviceName, successF, errorF);
  }

  static async readProfileFromAPI(successF, errorF) {
    await WrapperService.get(API_URL + '/profile', null, serviceName, successF, errorF);
  }

  static async readUsersByFacilityAndRole(facilityId, roleId, successF, errorF){
    await WrapperService.get(API_URL + '/facility/' + facilityId + '/role/' + roleId, null, serviceName, successF, errorF);
  }

  static postToAPI(user, successF, errorF) {
    WrapperService.post(API_URL, user, serviceName, successF, errorF);
  }

  static putToAPI(user, successF, errorF) {
    WrapperService.putWithErrorCause(API_URL + '/' + user.id, user, serviceName, successF, errorF);
  }

  static putProfileToAPI(profile, successF, errorF) {
    WrapperService.put(API_URL + '/profile', profile, serviceName, successF, errorF);
  }

  static deleteFromAPI(user, successF, errorF) {
    WrapperService.delete(API_URL + '/' + user.id, serviceName, successF, errorF);
  }

  static getElevatorHeader(successF, errorF) {
    WrapperService.get(API_URL + '/column/elevator', null, serviceName, successF, errorF);
  }

  static async saveElevatorHeader(header) {
    await WrapperService.post(API_URL + '/column/elevator', header, serviceName);
  }

  static getAdvertHeader(successF, errorF) {
    WrapperService.get(API_URL + '/column/advert', null, serviceName, successF, errorF);
  }

  static async saveAdvertHeader(header) {
    await WrapperService.post(API_URL + '/column/advert', header, serviceName);
  }

  static async typeahead(term, successF, errorF) {
    await WrapperService.get(API_URL + '/typeahead?search=' + encodeURI(term), null, serviceName, successF, errorF);
  }

  static async registerUser(users, roleName, successF, errorF) {
    await WrapperService.postWithErrorCause(API_URL + '/register?roleName=' + roleName, users, serviceName, successF, errorF);
  }

  static async resendRegisterMail(userId, roleName, successF, errorF) {
    let formData = new FormData();
    formData.append('roleName', roleName);
    await WrapperService.putWithErrorCause(API_URL + '/register/' + userId + '/mail', formData, serviceName, successF, errorF);
  }

  static async checkToDelete(userId, successF, errorF) {
    await WrapperService.get(API_URL + '/check-to-delete/' + userId, null, serviceName, successF, errorF);
  }

  static async updateUserLanguage(language, successF, errorF) {
    await WrapperService.put(API_URL + '/update-language/' + language, null, serviceName, successF, errorF);
  }

  static updateLoginTime(successF, errorF) {
    WrapperService.put(API_URL + '/update-login', null, serviceName, successF, errorF);
  }

  static async loadUsersByElevator(facilityId, successF, errorF){
    await WrapperService.get(API_URL + '/load-users-by-facility/' + facilityId, null, serviceName, successF, errorF);
  }

  static async loadUsersByCustomer(customerId, successF, errorF){
    await WrapperService.get(API_URL + '/load-users-by-customer/' + customerId, null, serviceName, successF, errorF);
  }
}
